<div class="ip-accumulator">
    <div class="ip-accumulator-details">
        <p
            [id]="accumulator?.network + '-' + accumulator?.level + '-' +  accumulator?.coverage + '-coverage'"
            class="h5">{{ accumulator?.coverage ?? '' | translate }}</p>
        <div
            [id]="accumulator?.network + '-' + accumulator?.level + '-' +  accumulator?.coverage + '-total'"
            class="ip-accumulator-value"><p class="body-regular">{{ 'TotalColon' | translate }}</p><p class="h5">{{ accumulator?.limit }}</p></div>
    </div>
    <vpg-simple-progress-bar
        [id]="accumulator?.network + '-' + accumulator?.level + '-' +  accumulator?.coverage + '-progress-bar'"
        class="ip-accumulators-progress-bar"
        [size]="'small'"
        [indicator]="false"
        [progress]="accumulator?.progress ?? 0">
    </vpg-simple-progress-bar>
    <div class="ip-accumulator-details">
        <div
            [id]="accumulator?.network + '-' + accumulator?.level + '-' +  accumulator?.coverage + '-spent'"
            class="ip-accumulator-value"><p class="body-regular">{{ 'SpentColon' | translate }}</p><p class="h5">{{ accumulator?.applied }}</p></div>
        <div
            [id]="accumulator?.network + '-' + accumulator?.level + '-' +  accumulator?.coverage + '-remaining'"
            class="ip-accumulator-value"><p class="body-regular">{{ 'RemainingColon' | translate }}</p><p class="h5">{{ accumulator?.remaining }}</p></div>
    </div>
</div>